(() => {
  const init = (root = document) => {
    root.querySelectorAll("[data-mv-countdown]").forEach((element) => {
      if (element.dataset.initialized) return;
      element.dataset.initialized = "true";
      const end = Date.parse(element.dataset.mvCountdown);
      if (!Number.isFinite(end)) return;
      const update = () => {
        const remaining = end - Date.now();
        if (remaining <= 0) {
          element.textContent =
            "The release time has arrived. Check current availability.";
          if (timer) clearInterval(timer);
          return;
        }
        const values = [
          Math.floor(remaining / 86400000),
          Math.floor(remaining / 3600000) % 24,
          Math.floor(remaining / 60000) % 60,
        ];
        const names = ["days", "hours", "minutes"];
        element.replaceChildren(
          ...values.map((value, i) => {
            const item = document.createElement("span");
            const number = document.createElement("strong");
            number.textContent = String(value).padStart(2, "0");
            item.append(number, ` ${names[i]}`);
            return item;
          }),
        );
      };
      let timer;
      update();
      if (end > Date.now())
        timer = setInterval(() => {
          if (!element.isConnected) clearInterval(timer);
          else update();
        }, 30000);
    });
  };
  document.addEventListener("keydown", (event) => {
    if (event.key !== "Escape") return;
    document.querySelectorAll(".mv-mobile-menu[open], .mv-shop-menu[open]").forEach((menu) => {
      menu.open = false;
      menu.querySelector("summary")?.focus();
    });
  });
  document.addEventListener("click", (event) => {
    document.querySelectorAll(".mv-mobile-menu[open], .mv-shop-menu[open]").forEach((menu) => {
      if (!menu.contains(event.target)) menu.open = false;
    });
  });
  init();
  document.addEventListener("shopify:section:load", (event) =>
    init(event.target),
  );
})();
